import React, { useState } from "react";
import { updateClaim } from "../lib/claims";
import { Modal, toast } from "./UI";

const STATUSES = ["Open", "In Review", "Resolved", "Rejected"];

const STATUS_STYLE = {
  "Open":      { background: "#E6F1FB", color: "#185FA5" },
  "In Review": { background: "#FAEEDA", color: "#854F0B" },
  "Resolved":  { background: "#E1F5EE", color: "#0F6E56" },
  "Rejected":  { background: "#FCEBEB", color: "#A32D2D" },
};

export default function ReviewClaimModal({ claim, onClose, onSaved }) {
  const [status,     setStatus]     = useState(claim.status);
  const [adminNotes, setAdminNotes] = useState(claim.adminNotes || "");
  const [saving,     setSaving]     = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await updateClaim(claim.id, status, adminNotes);
      toast("Claim updated!");
      onSaved();
      onClose();
    } catch (e) {
      toast(e.message, "error");
    } finally {
      setSaving(false);
    }
  };

  const TYPE_LABELS = {
    not_received:  "Package not received at warehouse",
    not_delivered: "Package shipped but not delivered",
    damaged:       "Package arrived damaged",
    other:         "Other issue",
  };

  return (
    <Modal title="Review claim" onClose={onClose} maxWidth={500}>
      {/* Claim info */}
      <div style={{ background: "var(--bg-soft)", borderRadius: "var(--radius)", padding: "12px 14px", marginBottom: 16 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
          <span style={{ fontSize: 13, fontWeight: 600 }}>{claim.customerName}</span>
          <span style={{ fontSize: 12, color: "var(--text-muted)" }}>{claim.customerEmail}</span>
        </div>
        <div style={{ fontSize: 13, fontWeight: 600, color: "var(--text-muted)", marginBottom: 4 }}>
          {TYPE_LABELS[claim.type] || claim.type}
        </div>
        {claim.packageId && (
          <div style={{ fontSize: 12, fontFamily: "monospace", color: "var(--text-muted)", marginBottom: 6 }}>
            Package: {claim.packageId}
          </div>
        )}
        <div style={{ fontSize: 14, lineHeight: 1.6 }}>{claim.description}</div>
      </div>

      <div className="form-row">
        <label>Status</label>
        <select value={status} onChange={e => setStatus(e.target.value)}>
          {STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>

      <div className="form-row">
        <label>Response / notes to customer</label>
        <textarea
          rows={3}
          value={adminNotes}
          onChange={e => setAdminNotes(e.target.value)}
          placeholder="Your response will be visible to the customer..."
        />
      </div>

      <div className="modal-footer">
        <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
        <button className="btn btn-primary" onClick={save} disabled={saving}>
          {saving ? "Saving..." : "Save"}
        </button>
      </div>
    </Modal>
  );
}
